// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * Known values for Azure App Configuration Audience
 */
export var KnownAppConfigAudience;
(function (KnownAppConfigAudience) {
    /**
     * Audience for Azure China
     */
    KnownAppConfigAudience["AzureChina"] = "https://appconfig.azure.cn";
    /**
     * Audience for Azure Government
     */
    KnownAppConfigAudience["AzureGovernment"] = "https://appconfig.azure.us";
    /**
     * Audience for Azure Public
     */
    KnownAppConfigAudience["AzurePublicCloud"] = "https://appconfig.azure.com";
})(KnownAppConfigAudience || (KnownAppConfigAudience = {}));
export { KnownSnapshotComposition, KnownConfigurationSnapshotStatus, } from "./generated/src/index.js";
//# sourceMappingURL=models.js.map